import { computed } from 'vue';

import { PERMANENT_FLAGS } from '@/constants/feature_flags';
import { useFeatureFlagStore } from '@/stores';

import useMinimalApp from '../useMinimalApp';

export function useAIChatAccess() {
  const { hasFeatureFlag } = useFeatureFlagStore();
  const { isMinimalView } = useMinimalApp();

  const blockAIChatAccess = computed(() =>
    hasFeatureFlag(PERMANENT_FLAGS.BLOCK_AI_CHAT_ACCESS),
  );

  const hasAccessToAiChat = computed(
    () => !(blockAIChatAccess.value || isMinimalView),
  );

  return { hasAccessToAiChat };
}
